// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friendplay {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.friendplay__header {
  flex: 0 0 auto;
  background: var(--palette-bg);
  box-shadow: 0 3px 8px rgba(28, 27, 26, 0.06);
}

.friendplay__board {
  padding: 0 var(--pad) 12px;
}

.friendplay__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 calc(var(--pad) + 8px) calc(env(safe-area-inset-bottom, 0px) + 28px);
}

.friendplay__venn {
  position: relative;
  width: 100%;
  aspect-ratio: 320 / 104;
  min-height: 7rem;
  margin: 16px 0 24px;
}

.friendplay__venn svg {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
}

.friendplay__venn-left {
  fill: var(--palette-surface-blue-soft);
}
.friendplay__venn-right {
  fill: var(--palette-accent-soft);
}
.friendplay__venn-shared {
  fill: #e6e0ee;
}
.friendplay__venn-edge {
  fill: none;
  stroke-width: 1.5;
}
.friendplay__venn-edge--left {
  stroke: var(--palette-secondary);
}
.friendplay__venn-edge--right {
  stroke: var(--palette-primary);
}

.friendplay__venn-links {
  position: absolute;
  inset: 0;
  width: 76.875%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: center;
  padding-top: 4px;
}

.friendplay__venn-links a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  color: var(--palette-text);
  text-decoration: none;
  border-radius: 8px;
  padding: 4px 0;
}

.friendplay__venn-count {
  font: 1.75rem/1.1 var(--font-display);
  font-variant-numeric: tabular-nums;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
}

.friendplay__venn-label {
  font-size: 0.75rem;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

.friendplay__venn-links a:hover {
  background: rgba(255, 255, 255, 0.4);
}

.friendplay__venn-links a:focus-visible,
.friendplay .majorSectionHeader:focus-visible {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 3px;
}

.friendplay__status {
  font-size: 0.85rem;
  color: var(--palette-text-muted);
  padding: 28px 0;
  text-align: center;
  line-height: 1.4;
}

.friendplay__hint {
  text-align: center;
  font-size: 0.8rem;
  color: var(--palette-text-muted);
  margin: 10px 0 4px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/friendPlayScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB","sourcesContent":[".friendplay {\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n}\n\n.friendplay__header {\n  flex: 0 0 auto;\n  background: var(--palette-bg);\n  box-shadow: 0 3px 8px rgba(28, 27, 26, 0.06);\n}\n\n.friendplay__board {\n  padding: 0 var(--pad) 12px;\n}\n\n.friendplay__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 0 calc(var(--pad) + 8px) calc(env(safe-area-inset-bottom, 0px) + 28px);\n}\n\n.friendplay__venn {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 320 / 104;\n  min-height: 7rem;\n  margin: 16px 0 24px;\n}\n\n.friendplay__venn svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  inset: 0;\n}\n\n.friendplay__venn-left {\n  fill: var(--palette-surface-blue-soft);\n}\n.friendplay__venn-right {\n  fill: var(--palette-accent-soft);\n}\n.friendplay__venn-shared {\n  fill: #e6e0ee;\n}\n.friendplay__venn-edge {\n  fill: none;\n  stroke-width: 1.5;\n}\n.friendplay__venn-edge--left {\n  stroke: var(--palette-secondary);\n}\n.friendplay__venn-edge--right {\n  stroke: var(--palette-primary);\n}\n\n.friendplay__venn-links {\n  position: absolute;\n  inset: 0;\n  width: 76.875%;\n  margin: auto;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  align-items: center;\n  padding-top: 4px;\n}\n\n.friendplay__venn-links a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  color: var(--palette-text);\n  text-decoration: none;\n  border-radius: 8px;\n  padding: 4px 0;\n}\n\n.friendplay__venn-count {\n  font: 1.75rem/1.1 var(--font-display);\n  font-variant-numeric: tabular-nums;\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 3px;\n}\n\n.friendplay__venn-label {\n  font-size: 0.75rem;\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.friendplay__venn-links a:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.friendplay__venn-links a:focus-visible,\n.friendplay .majorSectionHeader:focus-visible {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 3px;\n}\n\n.friendplay__status {\n  font-size: 0.85rem;\n  color: var(--palette-text-muted);\n  padding: 28px 0;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.friendplay__hint {\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--palette-text-muted);\n  margin: 10px 0 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
